(function () {
  'use strict';

  function money(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function initScrollSlider(scope, opts) {
    var track = scope.querySelector(opts.track);
    var dotsWrap = scope.querySelector(opts.dots);
    if (!track) return;

    var slides = track.querySelectorAll(opts.slide || '.cfs-product__slide, .cfs-hero__slide');
    if (!slides.length) return;

    var dots = dotsWrap ? dotsWrap.querySelectorAll(opts.dot || '[data-cfs-product-dot], [data-cfs-hero-dot]') : [];

    function setActive(index) {
      var i = Math.max(0, Math.min(index, slides.length - 1));
      if (dots.length) {
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === i);
        });
      }
      return i;
    }

    function scrollToIndex(index) {
      var i = setActive(index);
      var slide = slides[i];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    function syncFromScroll() {
      var scrollLeft = track.scrollLeft;
      var nearest = 0;
      var nearestDist = Infinity;
      slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.offsetLeft - scrollLeft);
        if (dist < nearestDist) {
          nearestDist = dist;
          nearest = i;
        }
      });
      setActive(nearest);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute(opts.dotAttr || 'data-cfs-product-dot'), 10);
        if (!isNaN(index)) scrollToIndex(index);
      });
    });

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncFromScroll, 60);
      },
      { passive: true }
    );

    syncFromScroll();
  }

  function initProductSliders(scope) {
    scope.querySelectorAll('[data-cfs-product-slider]').forEach(function (slider) {
      initScrollSlider(slider, {
        track: '[data-cfs-product-track]',
        dots: '[data-cfs-product-dots]',
        dot: '[data-cfs-product-dot]',
        dotAttr: 'data-cfs-product-dot',
        slide: '.cfs-product__slide'
      });
    });
  }

  function initHeroSlider(scope) {
    scope.querySelectorAll('[data-cfs-hero-slider]').forEach(function (hero) {
      initScrollSlider(hero, {
        track: '[data-cfs-hero-track]',
        dots: '[data-cfs-hero-dots]',
        dot: '[data-cfs-hero-dot]',
        dotAttr: 'data-cfs-hero-dot',
        slide: '.cfs-hero__slide'
      });
    });
  }

  function initHotspots(panelBody) {
    panelBody.querySelectorAll('[data-cfs-hotspot]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-cfs-hotspot');
        if (!index) return;

        panelBody.querySelectorAll('.cfs-hotspot').forEach(function (hotspot) {
          hotspot.classList.toggle('is-active', hotspot === btn);
        });

        var card = panelBody.querySelector('[data-cfs-product-index="' + index + '"]');
        if (!card) return;

        card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        card.classList.remove('is-shake');
        void card.offsetWidth;
        card.classList.add('is-shake');

        function onEnd() {
          card.classList.remove('is-shake');
          card.removeEventListener('animationend', onEnd);
        }
        card.addEventListener('animationend', onEnd);
      });
    });
  }

  function initProductCards(scope, moneyFormat) {
    var cards = scope.querySelectorAll('[data-cfs-product-card]');
    cards.forEach(function (card) {
      var dataEl = card.querySelector('[data-cfs-variants]');
      if (!dataEl) return;
      var variants = [];
      try {
        variants = JSON.parse(dataEl.textContent) || [];
      } catch (e) {
        variants = [];
      }
      if (!variants.length) return;

      var selects = card.querySelectorAll('[data-option-index]');
      var input = card.querySelector('[data-variant-id]');
      var price = card.querySelector('[data-cfs-price]');
      var button = card.querySelector('[data-cfs-add]');

      function syncVariant() {
        var selected = [];
        selects.forEach(function (sel) {
          selected.push(sel.value);
        });
        var found = variants.find(function (v) {
          if (!v.options || !v.options.length) return true;
          return v.options.every(function (opt, i) {
            return opt === selected[i];
          });
        });
        if (!found) found = variants[0];
        input.value = found.id;
        if (price) price.innerHTML = money(found.price || 0, moneyFormat);
        if (button) {
          button.disabled = !found.available;
          button.textContent = found.available ? 'Add to Bag' : 'Sold out';
        }
      }

      selects.forEach(function (sel) {
        sel.addEventListener('change', syncVariant);
      });

      syncVariant();
    });
  }

  function initDrawerContent(panelBody, moneyFormat) {
    initProductCards(panelBody, moneyFormat);
    initProductSliders(panelBody);
    initHeroSlider(panelBody);
    initHotspots(panelBody);
  }

  function initSection(section) {
    var drawer = section.querySelector('[data-cfs-drawer]');
    var panelBody = section.querySelector('[data-cfs-panel-body]');
    var panelTitle = section.querySelector('[data-cfs-panel-title]');
    var backdrop = section.querySelector('[data-cfs-close-backdrop]');
    var closeBtn = section.querySelector('[data-cfs-close-btn]');
    var moneyFormat = section.getAttribute('data-money-format') || '${{amount}}';

    if (!drawer || !panelBody) return;

    function closeDrawer() {
      section.classList.remove('is-open');
      document.documentElement.classList.remove('cfs-lock');
      panelBody.innerHTML = '';
      panelTitle.textContent = '';
    }

    function openDrawer(lookId, title) {
      var tpl = section.querySelector('#cfs-look-template-' + lookId);
      if (!tpl) return;
      panelBody.innerHTML = tpl.innerHTML;
      panelTitle.textContent = title || 'Shop the look';
      section.classList.add('is-open');
      document.documentElement.classList.add('cfs-lock');
      initDrawerContent(panelBody, moneyFormat);
    }

    section.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-open-look]');
      if (openBtn) {
        e.preventDefault();
        openDrawer(openBtn.getAttribute('data-open-look'), openBtn.getAttribute('data-look-title'));
        return;
      }
      if (e.target.closest('[data-cfs-close-btn]') || e.target.closest('[data-cfs-close-backdrop]')) {
        e.preventDefault();
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  }

  document.querySelectorAll('[data-cfs-section]').forEach(initSection);
})();
